// Affiliate redirect handler
// Move this to assets/affiliate-redirect.js for better caching

document.addEventListener('DOMContentLoaded', function() {
  const currentUrl = window.location.href;
  const loadScreen = document.querySelector('.load-screen');
  const loadingVideo = document.getElementById('loading__video');
  const skipButton = document.getElementById('skipButton');
  const loadingStatus = document.getElementById('loadingStatus');
  
  // Early exit if elements don't exist
  if (!loadScreen || !loadingVideo || !skipButton || !loadingStatus) return;

  // Function to check if the affiliate cookie is set
  function checkCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? true : false;
  }

  // Variables
  let videoEnded = false;
  let cookieSet = false;
  let redirectUrl = '';
  let checkInterval = null;

  // Function to handle redirect
  function performRedirect() {
    if (checkInterval) {
      clearInterval(checkInterval);
    }
    window.location.href = redirectUrl;
  }

  // Function to show skip button with animation
  function showSkipButton() {
    skipButton.classList.add('show');
    loadingStatus.textContent = 'Ready! Click skip or wait for video to complete.';
    loadingStatus.classList.add('show');
  }

  // Function to start checking for cookie and handle UI updates
  function startRedirectCheck(url) {
    redirectUrl = url;
    
    // Show initial loading status
    loadingStatus.classList.add('show');
    
    checkInterval = setInterval(function() {
      // Check if cookie exists
      if (checkCookie('scaaf_aid')) {
        if (!cookieSet) {
          // Cookie just got set
          cookieSet = true;
          showSkipButton();
          
          // If video already ended, redirect immediately
          if (videoEnded) {
            performRedirect();
          }
        }
      }
    }, 500);
  }

  // Add skip button functionality
  skipButton.addEventListener('click', function() {
    if (loadingVideo) {
      loadingVideo.pause();
    }
    performRedirect();
  });

  // Check if the URL contains 'sca_ref' or 'to_checkout'
  if (currentUrl.includes('sca_ref') && !currentUrl.includes('to_checkout')) {
    loadScreen.style.display = 'flex';
    loadScreen.classList.add('shown');
    const link = currentUrl.split('sca_ref=')[1];
    const url = `https://app.ntnk.io/account/signup?affiliate_link=${link}`;

    // Start checking for cookie
    startRedirectCheck(url);

    // Add event listener for video end
    loadingVideo.addEventListener('ended', () => {
      videoEnded = true;
      
      // If cookie is already set, redirect
      if (cookieSet) {
        performRedirect();
      } else {
        // Update status to show video ended but waiting for cookie
        loadingStatus.textContent = 'Video complete. Finalizing setup...';
      }
    });

  } else if (currentUrl.includes('to_checkout')) {
    loadScreen.style.display = 'flex';
    loadScreen.classList.add('shown');
    const link = currentUrl.split('items=')[1];
    const url = `https://ntnk.io/cart/${link.replace('&discount', '?discount')}`;

    // Start checking for cookie
    startRedirectCheck(url);

    // Add event listener for video end
    loadingVideo.addEventListener('ended', () => {
      videoEnded = true;
      
      // If cookie is already set, redirect
      if (cookieSet) {
        performRedirect();
      } else {
        // Update status to show video ended but waiting for cookie
        loadingStatus.textContent = 'Video complete. Finalizing setup...';
      }
    });
  }
});